export default "__VITE_ASSET__jfLzFdc9__$_?nuxt_component=async&nuxt_component_name=IconCle&nuxt_component_export=default__"